// @ts-strict-ignore
import { ProjectHeadVO, ProjectOptionVO, UserInfoVO } from '@project/model/vo/project.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { omit } from 'lodash';

@JsonObject('ProjectGroupVO')
export class ProjectGroupVO {
  private static readonly TRANSIENT_PROPERTIES: string[] = [];

  public static readonly ROOT_GROUP_DUMMY_ID: number = -2;
  public static readonly CAE_IMPORT_TYPE: string = 'CAE_TYPE';

  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('guid', 'String')
  public guid: string = undefined;

  @JsonProperty('groupName', 'String')
  public groupName: string = undefined;

  @JsonProperty('parentGroup', 'ProjectGroupVO')
  public parentGroup: ProjectGroupVO = undefined;

  @JsonProperty('projects', '[ProjectVO]')
  public projects: ProjectHeadVO[] = undefined;

  @JsonProperty('groups', '[ProjectGroupVO]')
  public groups: ProjectGroupVO[] = undefined;

  @JsonProperty('groupType', 'Number')
  public groupType: number = undefined;

  @JsonProperty('importType', 'String')
  public importType: string = undefined;

  @JsonProperty('isSharedReadOnly', 'Boolean')
  public isSharedReadOnly: boolean = undefined;

  @JsonProperty('childContentLoaded', 'Boolean')
  public childContentLoaded: boolean = undefined;

  @JsonProperty('options', '[ProjectOptionVO]')
  public options: ProjectOptionVO[] = undefined;

  @JsonProperty('comment', 'String')
  public comment: string = undefined;

  @JsonProperty('internalComment', 'String')
  public internalComment: string = undefined;

  @JsonProperty('isHidden', 'Boolean')
  public isHidden: boolean = undefined;

  @JsonProperty('isPinned', 'Boolean')
  public isPinned: boolean = undefined;

  @JsonProperty('groupOwner', 'UserInfoVO')
  public groupOwner: UserInfoVO = undefined;

  public toJSON() {
    const projectGroup = omit(this, ProjectGroupVO.TRANSIENT_PROPERTIES);
    // fix converting circular structure
    if (projectGroup.hasOwnProperty('projects')) {
      projectGroup.projects = [];
    }
    return projectGroup;
  }
}
